import React, { useEffect } from "react";
import "./index.scss";
import Share from "../../dynamic/ShareButton/src";
import { formatDate, brandColours } from "../../helpers";
// import { setResponsiveImage } from "../../helpers";
import {
  GenericDropdown,
  GenericNavDropdownOption
} from "../GenericLandingPage";

export const tournamentBannerGradeScript = () => {
  const eventName: HTMLElement | null = document.querySelector(
    ".tournament-hero__name"
  );

  if (eventName !== null) {
    const eventGrade = eventName.innerText.split(" ")[0];
    const WTT = [...brandColours.blue, ...brandColours.red];
    const isWTT = WTT.some(grade => eventGrade === grade);

    if (isWTT) {
      const parentNode = document.querySelector(".tournament-hero");
      const title = document.querySelector(".tournament-hero__title");
      let gradeBadge = document.createElement("div");
      gradeBadge.className = `tournament-hero__grade-badge${
        brandColours.red.some((grade: string) => eventGrade === grade)
          ? " red"
          : brandColours.blue.some((grade: string) => eventGrade === grade)
          ? " blue"
          : ""
      }`;
      gradeBadge.innerHTML = `<div class="logo"></div><div class="grade">${eventGrade}</div>`;
      if (parentNode !== null && title !== null) {
        title.insertBefore(gradeBadge, eventName);
        parentNode.classList.add("WTT");
      }
    }
  }
};

interface TournamentProps {
  TournamentName?: string;
  date?: string;
  HostNation?: string;
  Hospitality?: string;
  Surface?: string;
  PrizeMoney?: string;
  Grade?: string;
  heroImage?: string;
  LocationDesc?: string;
  tournamentBranding?: string;
  relatedTournaments?: GenericNavDropdownOption[];
  recognised?: boolean;
  circuitCode?: string;
}

const socialMedia = {
  showFacebook: true,
  showTwitter: true,
  showEmail: true,
  showWeibo: true,
  showLinkedIn: true,
  showWhatsApp: true
};

const TournamentHero = ({
  TournamentName = "W50 Nonthaburi",
  date = formatDate(new Date()).short,
  HostNation = "Unset",
  Hospitality = "Unset",
  Surface = "Hard",
  PrizeMoney = "Unset",
  Grade = "Unset",
  heroImage = "",
  LocationDesc = "",
  tournamentBranding = "",
  relatedTournaments,
  recognised = false,
  circuitCode = "MT"
}: TournamentProps) => {
  useEffect(() => {
    // setResponsiveImage({
    //   mobileImage: heroImage,
    //   tabletImage: heroImage,
    //   desktopImage: heroImage,
    //   elClassName: "tournament-hero"
    // });
    tournamentBannerGradeScript();
  });
  return (
    <>
      <div
        className={`tournament-hero${
          !heroImage ? " tournament-hero--no-image" : ""
        }`}
      >
        <div className="tournament-hero__content">
          <div className="container">
            <div className="tournament-hero__links">
              <a className="btn--back" href="#">
                <div className="hide--tablet hide--desktop">Back</div>
                <div className="hide--mobile">Back to {TournamentName}</div>
              </a>
              <div className="tournament-hero__share-link">
                <Share isRightAligned socialMedia={socialMedia} />
                <a href="/" className="tournament-hero__live">
                  Live
                </a>
                <a
                  href="/"
                  className="tournament-hero__live tournament-hero__live-stream"
                />
              </div>
            </div>
            <div
              className="tournament-hero__branding"
              style={{
                backgroundImage: `url("${tournamentBranding}")`,
                display: "none"
              }}
            />
            {/* <a
              target="_blank"
              href="http://www.uniqlo.com/uk/en/home/"
              className="tournament-hero__sponsor"
            >
              <img src="../../assets/images/bnp-paribas-logo.png" />
            </a> */}
            {circuitCode === "JT" ? (
              <a className="btn btn--h2h">Visit Davis Cup</a>
            ) : null}
            <div className="tournament-hero__title">
              {/* <span>Welcome to</span> */}
              <h1 className="tournament-hero__name">{TournamentName}</h1>
              {LocationDesc ? <h2>{LocationDesc}</h2> : null}
              {recognised ? <a className="recognised-tournament" /> : null}
              {/* <div
                className="tournament-hero__sponsor"
                style={{ backgroundImage: `url(${tournamentBranding})` }}
              /> */}
            </div>
          </div>
        </div>
        <div className="tournament-hero__details">
          <div className="container">
            {relatedTournaments ? (
              <div className="tournament-hero__year-navigation">
                <GenericDropdown
                  options={relatedTournaments.filter(value => {
                    return !value.selected;
                  })}
                  placeholder="Select year"
                />
              </div>
            ) : null}
            <div className="tournament-hero__details-items">
              <div className="tournament-hero__details-item">
                <span className="tournament-hero__label">Date: </span>
                <span className="tournament-hero__value">{date}</span>
              </div>
              <div className="tournament-hero__details-item">
                <span className="tournament-hero__label">Host nation: </span>
                <span className="tournament-hero__value">{HostNation}</span>
              </div>
              <div className="tournament-hero__details-item">
                <span className="tournament-hero__label">Hospitality: </span>
                <span className="tournament-hero__value">{Hospitality}</span>
              </div>
              <div className="tournament-hero__details-item">
                <span className="tournament-hero__label">Surface: </span>
                <span className="tournament-hero__value tournament-hero__surface tournament-hero__surface--H">
                  {Surface}
                </span>
              </div>
              <div className="tournament-hero__details-item">
                <span className="tournament-hero__label">Prize money: </span>
                <span className="tournament-hero__value">{PrizeMoney}</span>
              </div>
              <div className="tournament-hero__details-item">
                <span className="tournament-hero__label">Grade: </span>
                <span className="tournament-hero__value">{Grade}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="tournament-hero__details tournament-hero__details--mobile">
        {relatedTournaments ? (
          <div className="tournament-hero__year-navigation">
            <GenericDropdown
              options={relatedTournaments.filter(value => {
                return !value.selected;
              })}
              placeholder="Select year"
            />
          </div>
        ) : null}
        <div className="container">
          <div className="tournament-hero__details-item">
            <span className="tournament-hero__label">Date: </span>
            <span className="tournament-hero__value">{date}</span>
          </div>
          <div className="tournament-hero__details-item">
            <span className="tournament-hero__label">Host nation: </span>
            <span className="tournament-hero__value">{HostNation}</span>
          </div>
          <div className="tournament-hero__details-item">
            <span className="tournament-hero__label">Hospitality: </span>
            <span className="tournament-hero__value">{Hospitality}</span>
          </div>
          <div className="tournament-hero__details-item">
            <span className="tournament-hero__label">Surface: </span>
            <span className="tournament-hero__value">{Surface}</span>
          </div>
          <div className="tournament-hero__details-item">
            <span className="tournament-hero__label">Prize money: </span>
            <span className="tournament-hero__value">{PrizeMoney}</span>
          </div>
          <div className="tournament-hero__details-item">
            <span className="tournament-hero__label">Grade: </span>
            <span className="tournament-hero__value">{Grade}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default TournamentHero;
